import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiDeleteOrder } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

export const useDeleteOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: apiDeleteOrder,
    onSuccess: (_, orderId) => {
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.ORDERS] })
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.ORDER_DETAIL, orderId] })
      // useSealedVinylEntry 가 SEALED_ORDER_DETAIL 캐시 사용 — 취소 후 재진입 시 stale 한
      // (이미 취소된) 주문이 detail 로 잡히지 않도록 무효화 (usePatchOrder 와 동일 패턴)
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.SEALED_ORDER_DETAIL] })
    },
  })
}
